<template>
  <div class="t-lk-materials">
    <div class="t-lk-container">
      <div class="t-lk-materials-menu">
        <router-link
          v-for="(item, index) in menu"
          :to="{ name: item.linkName }"
          class="t-lk-materials-menu__item"
          :class="{ _active: item.linkName === $route.name }"
          :key="'materials' + index"
        >
          <img class="t-lk-materials-menu__img" :src="item.img" :alt="item.name" />
          <span>{{ item.name }}</span>
        </router-link>
      </div>
    </div>

    <transition name="fadeChange">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'materials',
  data() {
    return {
      menu: [
        {
          name: this.$root.staticText.lk.materialsOnlineCourses,
          img: '/dist/img/materials-online-courses.png',
          linkName: 'lk-materials-online-courses',
        },
        {
          name: this.$root.staticText.lk.materialsVendors,
          img: '/dist/img/materials-vendors.png',
          linkName: 'lk-materials-vendors',
        },
        {
          name: this.$root.staticText.lk.materialsWhiteLabel,
          img: '/dist/img/materials-white-label.png',
          linkName: 'lk-materials-white-label',
        },
      ],
    }
  },
  methods: {},
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/materials/index.vue